import React from 'react'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import * as amplitude from '@amplitude/analytics-browser'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import CoachLogo from '@components/coach-logo'
import { useStyles } from './styles'

const EventHostInfo = ({ event }) => {
  const classes = useStyles()
  const router = useRouter()
  const { coach, slug } = event
  const { id, name, coachProfile } = coach
  const {
    profilePhoto, title, memberType, certificationLevel,
  } = coachProfile || {}

  return (
    <>
      <Typography variant="h6" style={{ margin: '30px 0' }}>Event Host</Typography>
      <Box display="flex" alignItems="center">
        <Avatar
          src={profilePhoto}
          className={classes.coachAvatar}
          alt={`${name}'s profile picture`}
        >
          {(name || '').substring(0, 1)}
        </Avatar>
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography
            variant="h5"
            color="secondary"
          >
            {name}
          </Typography>
          {title ? (
            <Typography variant="caption" className={classes.coachTitle}>
              {title}
            </Typography>
          ) : null}
        </Box>
        <Box display="flex" ml={3}>
          <CoachLogo {...{ memberType, certificationLevel }} size="50px" />
        </Box>
      </Box>
      <Button
        variant="outlined"
        color="secondary"
        className={classes.messageButton}
        href={`${process.env.MY_PGA_COM_URL}/things-to-do/events/${slug}/messages`}
        onClick={() => amplitude.track('click-send-message', {
          event_name: event.title, coach_profile_id: id, coach_name: name, page_path: router.asPath,
        })}
      >
    Send a Message
      </Button>
    </>
  )
}

EventHostInfo.propTypes = {
  event: PropTypes.shape({
    coach: PropTypes.shape({
      coachProfile: PropTypes.shape({
        profilePhoto: PropTypes.string,
      }),
      name: PropTypes.string,
      profileUrl: PropTypes.string,
      id: PropTypes.string,
    }),
    slug: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
}
export default EventHostInfo
